export default __webpack_public_path__ + "static/media/Winter tree_primary.0b314748.jpg";